import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import {
  getBoldLabelText,
  getNormalLabelText,
} from '../../../util/Insight360Utils';
import { MEDIA_ICON_LIST } from '../../../constants';
import * as insight360Actions from '../../../actions/insight360Actions';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(MEDIA_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

class MediaComparisionDetail extends Component { 
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDeepDiveSlider = (value, deepDivePersonaObject) => {
    this.props.insight360Actions.showDeepDivePopup(value, deepDivePersonaObject);
  }
 
  render() {
  const { brandCategory, statement, brandDetail, selectedIcon,
        selectedTab, personaIndex } = this.props;

  const deepDivePersonaObject = {
    personaIndex,
    category: brandDetail.brandSubCategory,
    section: 'Media',
    selectedTab,
  };
  return (
  <div>
    {brandCategory !== undefined && (
      <div className="attitude-detail-comparision-grid pointer-cursor"
      onClick={() => this.renderDeepDiveSlider(true, deepDivePersonaObject)}>
        <div className="attitude-comparision-float">
          <div className="attitude-float">
            <div className="attitude-comparision-image-border attitude-float">
              {getImageIcon(selectedIcon) === undefined && (
                <div className="imageblock" />
              )}
              {getImageIcon(selectedIcon) !== undefined && (
                <img
                  alt="icon"
                  className="i360-demo-double-comparision-img"
                  src={getImageIcon(selectedIcon)}
                />
              )}
              <div className="attitude-comparision-icon-labels">
                {brandCategory}{' '}
              </div>
            </div>
          </div>
          <div>
            <div className="div-overflow">
              <div
                className="attitude-comparision-labels"
                title={statement}
              >
                <p className="brand-block-with-text">
                  <span style={{ fontWeight: 'bold' }}>
                    {getBoldLabelText(statement)}
                  </span>
                  <span>{getNormalLabelText(statement)}</span>
                </p>
              </div>
            </div>
            <div className="div-overflow">
              <div className="attitude-triple-comparision-metrics">
                INDEX:&nbsp;&nbsp;{brandDetail.index} |
                REACH:&nbsp;&nbsp;{brandDetail.pct}{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);
}             
}            

MediaComparisionDetail.propTypes = {
  brandCategory: PropTypes.string,
  statement: PropTypes.string,
  brandDetail: PropTypes.shape({
    brandSubCategory: PropTypes.number,
    index: PropTypes.number,
    pct: PropTypes.number,
  }),
  selectedIcon: PropTypes.string,
  insight360Actions: PropTypes.shape({
    showDeepDivePopup: PropTypes.func,
  }),
  personaIndex: PropTypes.number,
  selectedTab: PropTypes.string,
};


function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(MediaComparisionDetail);
